import { useState } from "react";
import { Button, Dialog, DialogContent } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { useAuthenticationMethod } from "@/hooks/use-authentication-method";

import NewUser from "./new-user";

export const NewUserButton = () => {
	const [open, setOpen] = useState(false);
	const { data: authMethod } = useAuthenticationMethod();

	if (authMethod?.name === "Saml") {
		return null;
	}

	return (
		<>
			<Button variant="contained" onClick={() => setOpen(true)} data-cy="list-view-add-new-button">
				<FormattedMessage id="Add New" defaultMessage="Add New" />
			</Button>
			<Dialog
				maxWidth="lg"
				fullWidth
				disableEscapeKeyDown
				open={open}
				onClose={(_, reason) => {
					if (reason !== "backdropClick") {
						setOpen(false);
					}
				}}
			>
				<DialogContent sx={{ p: 0 }}>
					<NewUser closeModal={() => setOpen(false)} />
				</DialogContent>
			</Dialog>
		</>
	);
};
